import api from './api';

export const chatApi = {
  // Pobierz listę konwersacji z ostatnimi wiadomościami
  getConversations: async () => {
    const response = await api.get('/chat/conversations', {
      timeout: 10000 // 10 sekund timeout
    });
    return response.data;
  },

  // Pobierz historię rozmowy z konkretnym użytkownikiem
  getConversation: async (userId, page = 0, size = 50) => {
    const response = await api.get(`/chat/conversation/${userId}`, {
      params: { page, size },
      timeout: 10000 // 10 sekund timeout
    });
    return response.data;
  },

  // Oznacz wiadomość jako przeczytaną
  markAsRead: async (messageId) => {
    const response = await api.put(`/chat/messages/${messageId}/read`, {}, {
      timeout: 10000 // 10 sekund timeout
    });
    return response.data;
  },

  // Pobierz liczbę nieprzeczytanych wiadomości
  getUnreadCount: async () => {
    const response = await api.get('/chat/unread-count', {
      timeout: 10000 // 10 sekund timeout
    });
    return response.data.count;
  },

  // Pobierz listę użytkowników z flagą online
  getUsers: async () => {
    const response = await api.get('/chat/users', {
      timeout: 10000 // 10 sekund timeout
    });
    return response.data;
  }
};

export default chatApi;
